import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

const DialogContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  margin-left: 0;
  padding: 90px 20px 23px;
  overflow: auto;

  background: ${getToken('color-neutral-lightest')};

  transition: height 750ms linear;

  will-change: height;

  ${screen.md} {
    top: 60px;
    left: 50%;

    width: 340px;
    height: auto;
    margin-left: -175px;
    padding: 90px 30px 23px;
    overflow: initial;

    border-radius: 4px;
  }

  input {
    box-sizing: border-box;
  }
`

export default DialogContent
